import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center","height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-center mb-4",
  style: {"color":"#ffffff"}
}, "CDP Hosting", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-center mb-4",
  style: {"color":"#ffffff"}
}, "Contact Us", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, {
      width: "450",
      class: "mx-auto"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers(_ctx.submitForm, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.Name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Name) = $event)),
              rules: _ctx.nameRules,
              label: "Name",
              outlined: "",
              dense: "",
              style: {"color":"#ffffff"}
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.Email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Email) = $event)),
              rules: _ctx.emailRules,
              label: "Email",
              outlined: "",
              dense: "",
              style: {"color":"#ffffff"}
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_v_textarea, {
              modelValue: _ctx.Subject,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Subject) = $event)),
              rules: _ctx.subjectRules,
              label: "Subject",
              outlined: "",
              dense: "",
              style: {"color":"#ffffff"}
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_v_select, {
              modelValue: _ctx.select,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.select) = $event)),
              items: _ctx.items,
              rules: _ctx.itemRules,
              label: "Reason",
              required: "",
              outlined: "",
              dense: "",
              style: {"color":"#ffffff"}
            }, null, 8, ["modelValue", "items", "rules"]),
            (_ctx.alertMessage)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: _ctx.alertType,
                  outlined: "",
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.alertMessage), 1)
                  ]),
                  _: 1
                }, 8, ["type"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              type: "submit",
              block: "",
              class: "mt-2",
              disabled: !_ctx.canSubmit()
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    })
  ]))
}